const setToLocalStorageAddBankAccount = (key, value) => {
  const data = JSON.parse(localStorage.getItem('addBankAccount')) || {}
  data[key] = value
  localStorage.setItem('addBankAccount', JSON.stringify(data))
}

const setToLocalStorageWithdrawal = (key, value) => {
  const data = JSON.parse(localStorage.getItem('cashWithdrawal')) || {}
  data[key] = value
  localStorage.setItem('cashWithdrawal', JSON.stringify(data))
}

// initial state
const state = () => ({
  // all: [],

  // Add Bank Account
  requestKeyExpiredTime: null,
  requestKeyAddBankAccount: (JSON.parse(localStorage.getItem('addBankAccount')) || {}).requestKeyAddBankAccount || null,
  validationString: (JSON.parse(localStorage.getItem('addBankAccount')) || {}).validationString || null,

  isAddBankAccountOnProcess: (JSON.parse(localStorage.getItem('addBankAccount')) || {}).isAddBankAccountOnProcess || false,
  whichProcessAddBankAccount: (JSON.parse(localStorage.getItem('addBankAccount')) || {}).whichProcessAddBankAccount || null, // (null | 'add') | 'verify' | 'photo' | 'otp'

  otpModeAddBankAccount: (JSON.parse(localStorage.getItem('addBankAccount')) || {}).otpModeAddBankAccount || 'email', // email | sms

  // Cash Withdrawal
  requestKeyWithdrawal: (JSON.parse(localStorage.getItem('cashWithdrawal')) || {}).requestKeyWithdrawal || null,
  whichProcessWithdrawal: (JSON.parse(localStorage.getItem('cashWithdrawal')) || {}).whichProcessWithdrawal || null, // (null | 'add') | 'verify' | 'photo' | 'otp'
  otpModeWithdrawal: (JSON.parse(localStorage.getItem('cashWithdrawal')) || {}).otpModeWithdrawal || 'email', // email | sms
})

// getters
const getters = {}

// actions
const actions = {
  // getAllProducts ({ commit }) {
  //   shop.getProducts(products => {
  //     commit('setProducts', products)
  //   })
  // },

  setRequestKeyAddBankAccount({ dispatch, commit }, value) {
    commit('setRequestKeyAddBankAccount', value)
    commit('setIsAddBankAccountOnProcess', true)
    commit('setWhichProcessAddBankAccount', 'verify')
    dispatch('updateAddBankAccountLocalStorage', { requestKeyAddBankAccount: value })
  },

  setValidationString({ dispatch, commit }, value) {
    commit('setValidationString', value)
    dispatch('updateAddBankAccountLocalStorage', { validationString: value })
  },

  /**
    * Update add bank account related data local storage
    * @param {Object} context
    * @param {Object} newValue
   */
  updateAddBankAccountLocalStorage({ state }, newValue) {
    setToLocalStorageAddBankAccount(newValue)
  },

  removeAddBankAccountLocalStorage({ commit }) {
    commit('setRequestKeyAddBankAccount', null)
    commit('setValidationString', null)
    commit('setIsAddBankAccountOnProcess', false)
    commit('setWhichProcessAddBankAccount', null)
    commit('setOtpModeAddBankAccount', 'email')
    localStorage.removeItem('addBankAccount')
  },

  // Cash Withdrawal
  /**
    * Update cash withdrawal related data local storage
    * @param {Object} context
    * @param {Object} newValue
   */
  updateWithdrawalLocalStorage({ state }, newValue) {
    setToLocalStorageWithdrawal(newValue)
  },
  
  setRequestKeyWithdrawal({ dispatch, commit }, value) {
    commit('setRequestKeyWithdrawal', value)
    dispatch('updateWithdrawalLocalStorage', { requestKeyWithdrawal: value })
  },

  removeCashWithdrawalLocalStorage({ commit }) {
    commit('setRequestKeyWithdrawal', null)
    commit('setOtpModeWithdrawal', 'email')
    localStorage.removeItem('cashWithdrawal')
  }
}

// mutations
const mutations = {
  // setProducts (state, products) {
  //   state.all = products
  // },

  // decrementProductInventory (state, { id }) {
  //   const product = state.all.find(product => product.id === id)
  //   product.inventory--
  // }

  setRequestKeyAddBankAccount(state, value) {
    state.requestKeyAddBankAccount = value

    const now = new Date()
    const twentyFourHoursFromNow = new Date(now.getTime() + (24 * 60 * 60 * 1000))
    state.requestKeyExpiredTime = twentyFourHoursFromNow
    setToLocalStorageAddBankAccount('requestKeyAddBankAccount', value)
  },

  setValidationString(state, value) {
    state.validationString = value
    setToLocalStorageAddBankAccount('validationString', value)
  },

  /**
    * Set the current process
    * @param {Object} state
    * @param {Boolean} value
   */
  setIsAddBankAccountOnProcess(state, value) {
    state.isAddBankAccountOnProcess = value
    setToLocalStorageAddBankAccount('isAddBankAccountOnProcess', value)
  },

  /**
    * Set the current process
    * @param {Object} state
    * @param {'add' | 'verify' | 'photo' | 'otp'} value
   */
  setWhichProcessAddBankAccount(state, value) {
    state.whichProcessAddBankAccount = value
    setToLocalStorageAddBankAccount('whichProcessAddBankAccount', value)
  },

  /**
    * Set the OTP mode Add Bank Account
    * @param {Object} state
    * @param {'mail' | 'sms'} value
   */
  setOtpModeAddBankAccount(state, value) {
    state.otpModeAddBankAccount = value
    setToLocalStorageAddBankAccount('otpModeAddBankAccount', value)
  },


  // Cash Withdrawal

  /**
    * Set the request key for cash withdrawal
    * @param {Object} state
    * @param {String} value
   */
  setRequestKeyWithdrawal(state, value) {
    state.requestKeyWithdrawal = value
    setToLocalStorageWithdrawal('requestKeyWithdrawal', value)
  },

  /**
    * Set the current process
    * @param {Object} state
    * @param {'idle' | 'otp'} value
   */
  setWhichProcessWithdrawal(state, value) {
    state.whichProcessWithdrawal = value
    setToLocalStorageWithdrawal('whichProcessWithdrawal', value)
  },

  /**
    * Set the OTP mode Cash Withdrawal
    * @param {Object} state
    * @param {'mail' | 'sms'} value
   */
  setOtpModeWithdrawal(state, value) {
    state.otpModeWithdrawal = value
    setToLocalStorageWithdrawal('otpModeWithdrawal', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}